import Card from 'components/Layout/Card';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserType } from 'utils/helpers';

const NewAiResume = () => {
  const navigate = useNavigate();
  const memberType = getUserType();

  return (
    <Card className="cp-22">
      <div className="text-14-400-24 color-title-navy">
        Build your professional resume using our AI Resume Builder and increase
        your chances of being shortlisted in conferences, publications, and job
        opportunities.
        <br />
        <span
          onClick={() =>
            navigate(`/${memberType}/career-support/build-ai-resume`)
          }
          style={{
            cursor: 'pointer',
          }}
        >
          Start Building Resume,{' '}
          <span
            className="text-16-600-20"
            style={{
              display: 'inline-block',
              background:
                'radial-gradient(50% 50% at 50% 50%, #CF36F5 0%, #3565FA 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontStyle: 'italic',
            }}
          >
            AI Resume
          </span>
        </span>
      </div>
    </Card>
  );
};

export default NewAiResume;
